// extracted by mini-css-extract-plugin
export default {"modalBody":"TopicTable_modalBody__iLrOz","modalContent":"TopicTable_modalContent__6I97l"};